import { CompanyProduct } from "services/companyProducts/companyProductsTypes";
import { type IssueFieldQuestionMap } from "services/issues/issuesStore";

export enum CompanyQuestion {
  VirtualOffice = "VIRTUAL_OFFICE",
  VirtualPlanSelect = "VIRTUAL_PLAN_SELECT",
  VirtualAddressSelect = "VIRTUAL_ADDRESS_SELECT",
  Description = "COMPANY_DESCRIPTION",
  Activities = "COMPANY_ACTIVITIES",
  AnnaTaxes = "COMPANY_INTERESTED_IN_ANNA_TAXES",
  VatRegistration = "COMPANY_VAT_REGISTRATION",
  ConfirmationStatement = "COMPANY_CONFIRMATION_STATEMENT",
  Check = "DIRECTOR_CHECK",
  Management = "DIRECTOR_MANAGEMENT",
  CancellationCover = "DIRECTOR_CANCELLATION_COVER",
  PayeRegistration = "DIRECTOR_PAYE_REGISTRATION",
}

export const ISSUE_FIELD_TO_QUESTION: IssueFieldQuestionMap<CompanyQuestion> = {
  country: CompanyQuestion.VirtualOffice,
  address: CompanyQuestion.VirtualOffice,
  nature_of_business: CompanyQuestion.Description,
  sic_codes: CompanyQuestion.Activities,
  check: CompanyQuestion.Check,
};

export const QUESTION_TO_PRODUCT: { [key in CompanyQuestion]?: CompanyProduct } = {
  [CompanyQuestion.AnnaTaxes]: CompanyProduct.Taxes,
  [CompanyQuestion.VatRegistration]: CompanyProduct.VatRegistration,
  [CompanyQuestion.ConfirmationStatement]: CompanyProduct.ConfirmationStatement,
  [CompanyQuestion.Management]: CompanyProduct.DirectorManagement,
  [CompanyQuestion.CancellationCover]: CompanyProduct.CancellationCover,
  [CompanyQuestion.PayeRegistration]: CompanyProduct.PayeRegistration,
};

export const QUESTION_TO_PATH: Record<CompanyQuestion, string> = {
  [CompanyQuestion.VirtualOffice]: "virtual-office",
  [CompanyQuestion.VirtualPlanSelect]: "virtual-plan-select",
  [CompanyQuestion.VirtualAddressSelect]: "virtual-address-select",
  [CompanyQuestion.Description]: "description",
  [CompanyQuestion.Activities]: "activities",
  [CompanyQuestion.AnnaTaxes]: "taxes",
  [CompanyQuestion.VatRegistration]: "vat-registration",
  [CompanyQuestion.ConfirmationStatement]: "confirmation-statement",
  [CompanyQuestion.Check]: "check",
  [CompanyQuestion.CancellationCover]: "cancellation-cover",
  [CompanyQuestion.PayeRegistration]: "paye-registration",
  [CompanyQuestion.Management]: "management",
};
